// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1zUdF","containerItemsCenter":"Skeleton_containerItemsCenter__39Vqn"};